<template>
    <el-table ref="elTable" border :data="tableData" style="width: 100%" :max-height="maxHeight">
      <!-- 承运物流公司 -->
      <el-table-column align="center" prop="provider" :label="this.$t('InternalSalesOrderDetailsSearchTable.providerss')" min-width="125"></el-table-column>
      <!-- 承运物流业务 -->
      <!-- <el-table-column align="center" prop="labelType" :label="this.$t('InternalSalesOrderDetailsSearchTable.totalPricess')"></el-table-column> -->
      <!-- 总运费（admin） -->
      <el-table-column v-if="!$store.getters.cusId" align="center" prop="totalPrice" :label="this.$t('InternalSalesOrderDetailsSearchTable.totalPrice')" min-width="125">
        <template slot-scope="scope">{{ formatTotalPrice(scope.row) }}</template>
      </el-table-column>
      <!-- 浮动运费（admin） -->
      <el-table-column v-if="!$store.getters.cusId" align="center" prop="ratePrice" :label="this.$t('billingPage.ratePrice')" min-width="125">
        <template slot-scope="scope">{{ scope.row.ratePrice ? (scope.row.ratePrice-0).toFixed(2) : scope.row.ratePrice }}</template>
      </el-table-column>
      <!-- 物流价格（user） -->
      <el-table-column v-if="$store.getters.cusId" align="center" prop="ratePrice" :label="this.$t('billingPage.costPrice')" min-width="125">
        <template slot-scope="scope">{{ scope.row.ratePrice ? (scope.row.ratePrice-0).toFixed(2) : scope.row.ratePrice }}</template>
      </el-table-column>
      <!-- 询价状态 -->
      <el-table-column align="center" prop="responseCode" :label="this.$t('InternalSalesOrderDetailsSearchTable.responseCode')" min-width="125">
        <template slot-scope="scope">
          <!-- <el-popover trigger="hover" placement="top" :content="scope.row.responseMsg" :disabled="!scope.row.responseMsg"> -->
              <div slot="reference" class="name-wrapper">
                {{ scope.row.responseCode }}
                <i v-if="scope.row.responseCode=='FAILED'" class="el-icon-warning" style="color:red"></i>
              </div>
          <!-- </el-popover> -->
        </template>
      </el-table-column>
      <!-- 失败原因 -->
      <el-table-column align="center" prop="responseMsg" :label="this.$t('InternalSalesOrderDetailsSearchTable.failReason')" min-width="200" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.responseCode=='FAILED' ? scope.row.responseMsg : '' }}</template>
      </el-table-column>
      <!-- 日期 -->
      <el-table-column align="center" prop="creationDate" :label="this.$t('InternalSalesOrderDetailsSearchTable.creationDate')" min-width="130">
        <template slot-scope="scope">{{ scope.row.creationDate | timeFilters(scope.row.creationDate) }}</template>
      </el-table-column>
    </el-table>
  </template>
  <script>
  import { stockApi } from '@/api';
  import { events_config } from '@/utils';

  export default {
    name: 'GateWayRatingPage',
    components: {},
    props: {
      hasBtn: {
        type: Boolean,
        default: false,
      },
      maxHeight: {
        type: [Number, String],
        default: 500,
      },
    },
    data() {
      return {
        selection: false,
        queryApi: stockApi.gateWayRating,
        // 查询参数
        queryParams: {
            orderCode: this.$route.query.code || null,
        },
        tableData: [],
      };
    },
    created() {
      events_config.listen('getDataOfSearchEvent', (data, data2) => {
        if (data2) {
          this.getDataOfSearch();
        }
      });
    },
    methods: {
      formatTotalPrice(row) {
        const freightCharge = Number(row.freightCharge) || 0;
        const fuelCharge = Number(row.fuelCharge) || 0;
        const totalPrice = freightCharge + fuelCharge;
        return totalPrice ? totalPrice.toFixed(2) : '';
      },
      async getDataOfSearch() {
        stockApi.gateWayRating(this.queryParams).then(res => {
          if (Array.isArray(res)) {
            this.tableData = res;
            this.$emit('selectList', this.tableData.filter(e => e.responseCode == 'SUCCESS').map(e => e.provider));
          }
        });
      },
      doLayout() {
        this.$refs.elTable && this.$refs.elTable.doLayout();
      },
    },
  };
  </script>
